import * as i0 from '@angular/core';
import { Injectable, Component, Output, ViewChild, Input, NgModule } from '@angular/core';
import { pluck, map, takeUntil, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as errorUtils from 'error-message-utility';
import * as i7 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { Subject, combineLatest } from 'rxjs';
import { environment } from 'environment-configurations';
import * as i1$1 from '@angular/router';
import * as i2 from '@angular/material/dialog';
import * as i3 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import * as i4 from 'ngx-toastr';
import * as i6 from '@ngrx/store';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from 'primeng/chips';
import * as i10 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i11 from '@progress/kendo-angular-toolbar';
import * as i12 from 'primeng/dropdown';
import * as i13 from 'primeng/multiselect';
import * as i14 from 'primeng/checkbox';
import * as i15 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class LibTemplateViewerService {
    constructor(http) {
        this.http = http;
        this.formState = {};
    }
    getDataSourceList(dataSourceType) {
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getJobPostingDetails(postPositionId) {
        return this.http.get(`/vd/formBuilder/get/postPosition/${postPositionId}/details`);
    }
    getTemplateDetails(templateId, postPositionId) {
        return this.http.get(`/vd/fb/get/talentAcq/templateBuilderId/${templateId}/jobId/${postPositionId}`);
    }
    getInvTemplateDetails(templateId) {
        return this.http.get(`/vd/fb/get/invoice/templateBuilderId/${templateId}`);
    }
    getSupplierList() {
        return this.http.get(`/vd/formBuilder/get/supplierList/info`);
    }
    getDocPath(payload) {
        return this.http.post(`/vd/fb/save/talentAcq/report`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getPositionDetails(payload) {
        return this.http.post(`/vd/formBuilder/get/postPositionList/details`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    saveFormState(key, value) {
        this.formState[key] = value;
    }
    getFormState(key) {
        return this.formState[key] || null;
    }
    clearFormState(key) {
        delete this.formState[key];
    }
}
LibTemplateViewerService.ɵfac = function LibTemplateViewerService_Factory(t) { return new (t || LibTemplateViewerService)(i0.ɵɵinject(i1.HttpClient)); };
LibTemplateViewerService.ɵprov = i0.ɵɵdefineInjectable({ token: LibTemplateViewerService, factory: LibTemplateViewerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateViewerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["templateEmailContentkendoeditor"];
const _c1 = ["templateEmailSignaturekendoeditor"];
function LibTemplateViewerComponent_h5_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 63);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("You are submitting ", ctx_r0.selectedApplicants == null ? null : ctx_r0.selectedApplicants.length, " Profiles");
} }
function LibTemplateViewerComponent_h5_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 63);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("You are sharing ", ctx_r1.selectedApplicants == null ? null : ctx_r1.selectedApplicants.length, " Open Positions");
} }
function LibTemplateViewerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵtext(2, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 66);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r2.jobPostingDetails == null ? null : ctx_r2.jobPostingDetails.taClientId == null ? null : ctx_r2.jobPostingDetails.taClientId.clientCompanyName) ? ctx_r2.jobPostingDetails == null ? null : ctx_r2.jobPostingDetails.taClientId == null ? null : ctx_r2.jobPostingDetails.taClientId.clientCompanyName : "--");
} }
function LibTemplateViewerComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵtext(2, "Job Position");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 66);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r3.jobPostingDetails == null ? null : ctx_r3.jobPostingDetails.jobPosition == null ? null : ctx_r3.jobPostingDetails.jobPosition.name) ? ctx_r3.jobPostingDetails == null ? null : ctx_r3.jobPostingDetails.jobPosition == null ? null : ctx_r3.jobPostingDetails.jobPosition.name : "--");
} }
function LibTemplateViewerComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2, "Select from Template");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 68);
    i0.ɵɵlistener("onChange", function LibTemplateViewerComponent_div_10_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onChangeTemplateType($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r4.templateTypes);
} }
function LibTemplateViewerComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 69);
    i0.ɵɵtext(2, "Select Suppliers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-multiSelect", 70);
    i0.ɵɵlistener("onChange", function LibTemplateViewerComponent_div_11_Template_p_multiSelect_onChange_3_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.storeSelectedOptions($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r5.supplierList)("showToggleAll", true);
} }
function LibTemplateViewerComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Create your own template by adding the content(");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4, "Select the required template attributes on the left hand side to proceed");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, ")");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibTemplateViewerComponent_div_95_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelementContainerStart(1, 74);
    i0.ɵɵelementStart(2, "p-checkbox", 75);
    i0.ɵɵlistener("onChange", function LibTemplateViewerComponent_div_95_div_1_Template_p_checkbox_onChange_2_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.CandidateSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const check_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r18);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", check_r17.get("name").value)("value", check_r17.get("isActive").value);
} }
function LibTemplateViewerComponent_div_95_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵtemplate(1, LibTemplateViewerComponent_div_95_div_1_Template, 3, 3, "div", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.selectedCandidateDetail.controls);
} }
function LibTemplateViewerComponent_div_96_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelementStart(2, "h5", 69);
    i0.ɵɵtext(3, "Position Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 76);
    i0.ɵɵelement(5, "kendo-editor", 77, 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", true);
} }
function LibTemplateViewerComponent_div_97_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelementStart(2, "h5", 69);
    i0.ɵɵtext(3, "Footer Content");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 76);
    i0.ɵɵelement(5, "kendo-editor", 78, 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibTemplateViewerComponent_div_98_p_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 83);
    i0.ɵɵlistener("click", function LibTemplateViewerComponent_div_98_p_button_2_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.openCandidateExcel(); });
    i0.ɵɵelementEnd();
} }
function LibTemplateViewerComponent_div_98_p_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 84);
    i0.ɵɵlistener("click", function LibTemplateViewerComponent_div_98_p_button_3_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.openCandidateExcel(); });
    i0.ɵɵelementEnd();
} }
function LibTemplateViewerComponent_div_98_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "div", 64);
    i0.ɵɵtemplate(2, LibTemplateViewerComponent_div_98_p_button_2_Template, 1, 0, "p-button", 81);
    i0.ɵɵtemplate(3, LibTemplateViewerComponent_div_98_p_button_3_Template, 1, 0, "p-button", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r11.formBuilderInfo == null ? null : ctx_r11.formBuilderInfo.formName) !== "Submit To Suppliers");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r11.formBuilderInfo == null ? null : ctx_r11.formBuilderInfo.formName) === "Submit To Suppliers");
} }
class LibTemplateViewerComponent {
    constructor(router, route, dialog, clipboardService, toastr, apiService, store, cdr, fb, el, renderer) {
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.clipboardService = clipboardService;
        this.toastr = toastr;
        this.apiService = apiService;
        this.store = store;
        this.cdr = cdr;
        this.fb = fb;
        this.el = el;
        this.renderer = renderer;
        this.destroy$ = new Subject();
        this.templateTypes = [];
        this.selectedApplicants = [];
        this.selectedJobPost = null;
        this.observableSubscription$ = new Subject();
        this.candidatePlaceholders = [];
        this.templateId = '';
        this.isEmailFromError = false;
        this.isEmailToError = false;
        this.isEmailCCError = false;
        this.currentStep = null;
    }
    ngOnInit() {
        var _a, _b;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.fbRole = sessionStorage.getItem('fbRole');
        this.selectedApplicants = JSON.parse(sessionStorage.getItem('selectedRowIds'));
        this.selectedJobPost = JSON.parse(sessionStorage.getItem("fbFormDataDTO"));
        console.log(this.selectedJobPost);
        this.jobPostPositionId = 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
        this.templateForm = this.fb.group({
            //   clientId: new FormControl(null, Validators.required),
            //  jobId: new FormControl(null, Validators.required),
            emailFrom: new FormControl(null),
            emailTo: new FormControl(null, ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'Client Invoicing' ? null : Validators.required),
            emailCC: new FormControl(null),
            templateId: new FormControl(''),
            emailSubject: new FormControl(null, ((_b = this.formBuilderInfo) === null || _b === void 0 ? void 0 : _b.formName) === 'Client Invoicing' ? null : Validators.required),
            emailText: new FormControl(null, this.isSubmitToSuppliers() ? Validators.required : null),
            emailTemplateContent: new FormControl(null),
            emailSignature: new FormControl(null, this.isSubmitToSuppliers() ? Validators.required : null),
            selectedCandidateDetail: this.fb.array([]),
            selectedCandidateDetails: new FormControl([]),
            docPath: new FormControl()
        });
        // Add dataListForm to the group using fromGrpName as the control name
        this.group.addControl(this.inputParams.name, this.templateForm);
        this.loadDropdownData();
        this.loadSupplierDropdownData();
        this.getPositionDetails();
        if (this.formBuilderInfo.formName === 'Submit To Suppliers') {
            this.loadPositionData();
        }
        const savedValue = this.apiService.getFormState(this.inputParams.name);
        if (savedValue) {
            this.templateForm.patchValue(savedValue);
        }
        this.route.queryParams.subscribe((params) => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                this.apiService.clearFormState(this.inputParams.name);
            }
            if (this.currentStep && stepParameter && this.currentStep !== stepParameter) {
                this.saveFormState();
            }
            this.currentStep = stepParameter;
            if (stepParameter) {
                const savedValue = this.apiService.getFormState(this.inputParams.name);
                if (savedValue) {
                    this.templateForm.patchValue(savedValue);
                    this.templateForm.updateValueAndValidity();
                }
            }
        });
    }
    getLatestRowID() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        return fbFormDataDTO[fbFormDataDTO.length - 1].id;
    }
    isSubmitToSuppliers() {
        var _a;
        return ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'Submit To Suppliers';
    }
    get selectedCandidateDetail() {
        return this.templateForm.get('selectedCandidateDetail');
    }
    getPositionDetails() {
        if (this.selectedJobPost && this.jobPostPositionId) {
            this.apiService.getJobPostingDetails(this.jobPostPositionId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe(response => {
                if (response.status == 200) {
                    this.jobPostingDetails = response.data;
                }
            });
        }
    }
    loadDropdownData() {
        combineLatest([
            //this.referenceLibraryService.getReferenceData('IMMTYP'),
            this.apiService.getDataSourceList('FB_TA_TEMPLATE_BUILDER'),
            this.apiService.getDataSourceList('FB_EMAIL_CLIENT_MGR'),
            this.apiService.getDataSourceList('FB_HR__INV_TEMPLATE_BUILDER')
        ])
            .pipe(take(1))
            .subscribe((response) => {
            this.templateTypes = this.fbRole === 'HR ADMIN' ? response[2] : response[0]; //response[0]
            this.candidatePlaceholders = response[1];
            this.templateTypes.unshift({
                code: "",
                name: "Create New",
                id: ''
            });
            this.initializeCandidateExcelOption();
        });
    }
    loadSupplierDropdownData() {
        this.apiService.getSupplierList()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status == 200) {
                this.supplierList = response.data;
            }
        });
    }
    initializeCandidateExcelOption() {
        var selectedCandidateDetail = this.templateForm.get("selectedCandidateDetail");
        selectedCandidateDetail.clear();
        this.candidatePlaceholders.forEach(value => {
            selectedCandidateDetail.push(this.fb.group({
                isActive: false,
                name: value.name,
                id: value.id,
                code: value.code
            }));
        });
        this.templateForm.get('selectedCandidateDetails').setValue([]);
        this.templateForm.updateValueAndValidity();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            const toolbar = this.el.nativeElement.querySelector('.readonly-kendo kendo-editor kendo-toolbar');
            //const readOnly = this.el.nativeElement.querySelector('.readonly-kendo kendo-editor .k-readonly');
            if (toolbar) {
                this.renderer.setStyle(toolbar, 'display', 'none');
                //this.renderer.setStyle(readOnly, 'opacity', '0.8');
            }
        }, 100);
        this.formChangesSubscription = this.templateForm.statusChanges.subscribe(() => {
            if (this.templateForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onChangeTemplateType(e) {
        var _a, _b;
        this.templateId = e.value;
        this.templateForm.reset();
        if (this.templateId) {
            this.loadTemplateData(this.templateId);
            (_a = this.templateForm.get('templateId')) === null || _a === void 0 ? void 0 : _a.setValue(this.templateId);
        }
        else {
            this.templateForm.reset();
            this.getDocPathDetails = null;
            (_b = this.templateForm.get('templateId')) === null || _b === void 0 ? void 0 : _b.setValue('');
        }
        this.initializeCandidateExcelOption();
    }
    getDocPath(id) {
        let payload = {
            "actionName": "SUBMIT TO CLIENTS",
            "jobPostPositionId": this.jobPostPositionId,
            "selectedMlIds": JSON.parse(sessionStorage.getItem("selectedRowIds")),
            "tbuilderId": Number(id),
        };
        this.apiService.getDocPath(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status == 200) {
                this.getDocPathDetails = response === null || response === void 0 ? void 0 : response.data;
                this.templateForm.get('docPath').setValue(this.getDocPathDetails);
                this.templateForm.updateValueAndValidity();
                this.cdr.detectChanges();
            }
        });
    }
    loadPositionData() {
        let payload = {
            "actionName": "SUBMIT TO CLIENTS",
            "selectedMlIds": JSON.parse(sessionStorage.getItem("selectedRowIds"))
        };
        this.apiService.getPositionDetails(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status == 200) {
                this.templateDetails = response === null || response === void 0 ? void 0 : response.data;
                const combinedEmailContent = this.templateDetails
                    .map(detail => detail.emailTemplateContent)
                    .join('\n\n');
                this.templateForm.patchValue({ emailTemplateContent: combinedEmailContent });
                // this.templateForm.patchValue(this.templateDetails);        
                //this.getDocPath(id);
            }
        });
    }
    loadTemplateData(id) {
        var _a;
        const apiCall = ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'Client Invoicing'
            ? this.apiService.getInvTemplateDetails(id)
            : this.apiService.getTemplateDetails(id, this.jobPostPositionId);
        apiCall.pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            var _a;
            if (response.status === 200) {
                this.templateDetails = response.data;
                //sessionStorage.setItem('templateDetaisId', this.templateDetails.id);
                this.templateForm.patchValue(this.templateDetails);
                if (((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) !== 'Client Invoicing') {
                    this.getDocPath(id);
                }
            }
        });
    }
    storeSelectedOptions(event) {
        this.selectedTemplates = event.value;
        console.log(this.selectedTemplates, 'selectedTemplates');
        const selectedTemplateNames = this.selectedTemplates.map(template => template.communicationEmailId);
        const emailToControl = this.templateForm.get('emailTo');
        let currentEmails = emailToControl.value || [];
        currentEmails = this.syncChipsWithDropdown(currentEmails, selectedTemplateNames);
        emailToControl.setValue(currentEmails);
    }
    syncChipsWithDropdown(currentEmails, selectedTemplateNames) {
        selectedTemplateNames.forEach(communicationEmailId => {
            if (!currentEmails.includes(communicationEmailId)) {
                currentEmails.push(communicationEmailId);
            }
        });
        currentEmails = currentEmails.filter(email => selectedTemplateNames.includes(email));
        return currentEmails;
    }
    openCandidateExcel() {
        let path = '';
        if (this.getDocPathDetails && this.getDocPathDetails.includes("var/www/")) {
            path = environment.appUrl + this.getDocPathDetails.replace('var/www/', '');
        }
        if (this.getDocPathDetails && this.getDocPathDetails.includes("/var/imagility/uploads/")) {
            path = environment.docs + this.getDocPathDetails.replace('/var/imagility/uploads/', '');
        }
        window.open(`${path}`, "_blank");
    }
    CandidateSelected(e) {
        this.templateForm.get('selectedCandidateDetails').setValue([]);
        let selectedCandidateDetails = [];
        this.templateForm.get('selectedCandidateDetail').value.forEach(value => {
            if (value.isActive == true) {
                selectedCandidateDetails.push(value.code);
            }
        });
        this.templateForm.get('selectedCandidateDetails').setValue(selectedCandidateDetails);
    }
    validateEmailAddress(event, item) {
        let inValidEmail = false;
        if (event.value.match("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")) {
            inValidEmail = false;
        }
        else {
            inValidEmail = true;
        }
        switch (item) {
            case 'from':
                this.isEmailFromError = inValidEmail;
            case 'to':
                this.isEmailToError = inValidEmail;
                if (inValidEmail) {
                    this.templateForm.get('emailTo').value.pop();
                }
            case 'cc':
                this.isEmailCCError = inValidEmail;
                if (inValidEmail) {
                    this.templateForm.get('emailCC').value.pop();
                }
        }
        this.templateForm.updateValueAndValidity();
    }
    saveFormState() {
        const control = this.group.get(this.inputParams.name);
        control.patchValue(this.templateForm.value);
        control.updateValueAndValidity();
        this.apiService.saveFormState(this.inputParams.name, control.value);
    }
    ngOnDestroy() {
        this.formChangesSubscription.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
LibTemplateViewerComponent.ɵfac = function LibTemplateViewerComponent_Factory(t) { return new (t || LibTemplateViewerComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.MatDialog), i0.ɵɵdirectiveInject(i3.ClipboardService), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(LibTemplateViewerService), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i7.FormBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
LibTemplateViewerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibTemplateViewerComponent, selectors: [["lib-template-viewer"]], viewQuery: function LibTemplateViewerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateEmailContentkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateEmailSignaturekendoeditor = _t.first);
    } }, inputs: { inputParams: "inputParams", group: "group", formBuilderInfo: "formBuilderInfo" }, outputs: { templateEmailContentkendoeditor: "templateEmailContentkendoeditor", templateEmailSignaturekendoeditor: "templateEmailSignaturekendoeditor" }, decls: 99, vars: 19, consts: [[1, "container-fluid"], [3, "formGroup"], [1, "row"], [1, "col-md-12"], [1, "font-weight-bold", "title-style", "mb-3"], ["class", "heading", 4, "ngIf"], ["class", "col-3", 4, "ngIf"], ["class", "form-group col-12", 4, "ngIf"], [1, "col-12"], [4, "ngIf"], ["id", "templateBuilder", 1, "row", "title", "headerEditor", "fr-section-border"], [1, "form-row"], [3, "ngClass"], [1, "p-form-note"], ["formControlName", "emailTo", "separator", ",", "required", "", 1, "form-group", "col-12", "ui-chips", 3, "allowDuplicate", "onAdd"], ["formControlName", "emailCC", "separator", ",", 1, "form-group", "col-12", 3, "allowDuplicate", "onAdd"], [1, "form-group", "col-md-12"], ["type", "text", "formControlName", "emailSubject", "placeholder", "Subject", "required", "", 1, "im-input", "w-100"], [1, "row", "title", "contentEditor", "fr-section-border"], [2, "max-height", "600px", "overflow", "auto", "height", "506px", 3, "formControlName"], ["templateEmailContentkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["class", "row mt-4 mb-4", "formArrayName", "selectedCandidateDetail", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "row docPathSection", 4, "ngIf"], [1, "heading"], [1, "col-3"], [1, "labelHeading", "headlbl"], [1, "labelHeading"], [1, "form-group", "col-12"], ["optionLabel", "name", "placeholder", "Select", "formControlName", "templateId", "optionValue", "id", 1, "d-block", "w-100", 3, "options", "onChange"], [1, "required"], ["placeholder", "Select", "formControlName", "templateId", "optionLabel", "supplierName", 1, "remove_border", 3, "options", "showToggleAll", "onChange"], ["formArrayName", "selectedCandidateDetail", 1, "row", "mt-4", "mb-4"], ["class", "col-2 p-1", 4, "ngFor", "ngForOf"], [1, "col-2", "p-1"], [3, "formGroupName"], ["formControlName", "isActive", "name", "checkVal", "binary", "true", 3, "label", "value", "onChange"], [1, "col-12", "readonly-kendo"], ["formControlName", "emailTemplateContent", 2, "max-height", "600px", "overflow", "auto", "height", "506px", 3, "readonly"], ["formControlName", "emailSignature", 2, "max-height", "300px", "overflow", "auto", "height", "206px"], ["templateEmailSignaturekendoeditor", ""], [1, "row", "docPathSection"], ["label", "Candiate Details.xls", "rounded", "true", "severity", "secondary", "icon", "pi pi-paperclip", "iconPos", "left", 3, "click", 4, "ngIf"], ["label", "Position Details.pdf", "rounded", "true", "severity", "secondary", "icon", "pi pi-paperclip", "iconPos", "left", 3, "click", 4, "ngIf"], ["label", "Candiate Details.xls", "rounded", "true", "severity", "secondary", "icon", "pi pi-paperclip", "iconPos", "left", 3, "click"], ["label", "Position Details.pdf", "rounded", "true", "severity", "secondary", "icon", "pi pi-paperclip", "iconPos", "left", 3, "click"]], template: function LibTemplateViewerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, LibTemplateViewerComponent_h5_5_Template, 2, 1, "h5", 5);
        i0.ɵɵtemplate(6, LibTemplateViewerComponent_h5_6_Template, 2, 1, "h5", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵtemplate(8, LibTemplateViewerComponent_div_8_Template, 5, 1, "div", 6);
        i0.ɵɵtemplate(9, LibTemplateViewerComponent_div_9_Template, 5, 1, "div", 6);
        i0.ɵɵtemplate(10, LibTemplateViewerComponent_div_10_Template, 4, 1, "div", 7);
        i0.ɵɵtemplate(11, LibTemplateViewerComponent_div_11_Template, 4, 2, "div", 7);
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵtemplate(13, LibTemplateViewerComponent_div_13_Template, 6, 0, "div", 9);
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵelementStart(15, "div", 3);
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵelementStart(17, "label", 12);
        i0.ɵɵtext(18, "To ");
        i0.ɵɵelementStart(19, "small", 13);
        i0.ɵɵtext(20, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "p-chips", 14);
        i0.ɵɵlistener("onAdd", function LibTemplateViewerComponent_Template_p_chips_onAdd_21_listener($event) { return ctx.validateEmailAddress($event, "to"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 3);
        i0.ɵɵelementStart(23, "div", 11);
        i0.ɵɵelementStart(24, "label");
        i0.ɵɵtext(25, "CC ");
        i0.ɵɵelementStart(26, "small", 13);
        i0.ɵɵtext(27, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "p-chips", 15);
        i0.ɵɵlistener("onAdd", function LibTemplateViewerComponent_Template_p_chips_onAdd_28_listener($event) { return ctx.validateEmailAddress($event, "cc"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 3);
        i0.ɵɵelementStart(30, "div", 11);
        i0.ɵɵelementStart(31, "div", 16);
        i0.ɵɵelementStart(32, "label", 12);
        i0.ɵɵtext(33, "Subject");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(34, "input", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 18);
        i0.ɵɵelementStart(36, "div", 3);
        i0.ɵɵelementStart(37, "div", 2);
        i0.ɵɵelementStart(38, "div", 8);
        i0.ɵɵelementStart(39, "h5", 12);
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 8);
        i0.ɵɵelementStart(42, "kendo-editor", 19, 20);
        i0.ɵɵelementStart(44, "kendo-toolbar");
        i0.ɵɵelementStart(45, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(46, "kendo-toolbar-button", 21);
        i0.ɵɵelement(47, "kendo-toolbar-button", 22);
        i0.ɵɵelement(48, "kendo-toolbar-button", 23);
        i0.ɵɵelement(49, "kendo-toolbar-button", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(51, "kendo-toolbar-button", 25);
        i0.ɵɵelement(52, "kendo-toolbar-button", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(54, "kendo-toolbar-button", 27);
        i0.ɵɵelement(55, "kendo-toolbar-button", 28);
        i0.ɵɵelement(56, "kendo-toolbar-button", 29);
        i0.ɵɵelement(57, "kendo-toolbar-button", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(58, "kendo-toolbar-dropdownlist", 31);
        i0.ɵɵelement(59, "kendo-toolbar-dropdownlist", 32);
        i0.ɵɵelement(60, "kendo-toolbar-dropdownlist", 33);
        i0.ɵɵelement(61, "kendo-toolbar-colorpicker", 34);
        i0.ɵɵelement(62, "kendo-toolbar-colorpicker", 35);
        i0.ɵɵelementStart(63, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(64, "kendo-toolbar-button", 36);
        i0.ɵɵelement(65, "kendo-toolbar-button", 37);
        i0.ɵɵelement(66, "kendo-toolbar-button", 38);
        i0.ɵɵelement(67, "kendo-toolbar-button", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(68, "kendo-toolbar-button", 40);
        i0.ɵɵelement(69, "kendo-toolbar-button", 41);
        i0.ɵɵelementStart(70, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(71, "kendo-toolbar-button", 42);
        i0.ɵɵelement(72, "kendo-toolbar-button", 43);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(73, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(74, "kendo-toolbar-button", 44);
        i0.ɵɵelement(75, "kendo-toolbar-button", 45);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(76, "kendo-toolbar-button", 46);
        i0.ɵɵelement(77, "kendo-toolbar-button", 47);
        i0.ɵɵelement(78, "kendo-toolbar-button", 48);
        i0.ɵɵelement(79, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(80, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(81, "kendo-toolbar-button", 49);
        i0.ɵɵelement(82, "kendo-toolbar-button", 50);
        i0.ɵɵelement(83, "kendo-toolbar-button", 51);
        i0.ɵɵelement(84, "kendo-toolbar-button", 52);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(86, "kendo-toolbar-button", 53);
        i0.ɵɵelement(87, "kendo-toolbar-button", 54);
        i0.ɵɵelement(88, "kendo-toolbar-button", 55);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(89, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(90, "kendo-toolbar-button", 56);
        i0.ɵɵelement(91, "kendo-toolbar-button", 57);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(92, "kendo-toolbar-button", 58);
        i0.ɵɵelementStart(93, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(94, "kendo-toolbar-button", 59);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(95, LibTemplateViewerComponent_div_95_Template, 2, 1, "div", 60);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(96, LibTemplateViewerComponent_div_96_Template, 7, 1, "div", 61);
        i0.ɵɵtemplate(97, LibTemplateViewerComponent_div_97_Template, 7, 0, "div", 61);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(98, LibTemplateViewerComponent_div_98_Template, 4, 2, "div", 62);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.templateForm);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Client Invoicing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Client Invoicing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Client Invoicing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Client Invoicing" ? "" : "required");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("allowDuplicate", false);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("allowDuplicate", false);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Client Invoicing" ? "" : "required");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Client Invoicing" ? "" : "required");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate((ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers" ? "Body Content" : "Email Content Section");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formControlName", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers" ? "emailText" : "emailTemplateContent");
        i0.ɵɵadvance(53);
        i0.ɵɵproperty("ngIf", ctx.templateId == "" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Submit To Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Client Invoicing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Submit To Suppliers");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.getDocPathDetails);
    } }, directives: [i7.ɵangular_packages_forms_forms_ba, i7.NgControlStatusGroup, i7.FormGroupDirective, i8.NgIf, i8.NgClass, i9.Chips, i7.NgControlStatus, i7.FormControlName, i7.RequiredValidator, i7.DefaultValueAccessor, i10.EditorComponent, i11.ToolBarComponent, i11.ToolBarButtonGroupComponent, i11.ToolBarButtonComponent, i10.EditorBoldButtonDirective, i10.EditorItalicButtonDirective, i10.EditorUnderlineButtonDirective, i10.EditorStrikethroughButtonDirective, i10.EditorSubscriptButtonDirective, i10.EditorSuperscriptButtonDirective, i10.EditorAlignLeftButtonDirective, i10.EditorAlignCenterButtonDirective, i10.EditorAlignRightButtonDirective, i10.EditorAlignJustifyButtonDirective, i10.EditorFormatComponent, i10.EditorFontSizeComponent, i10.EditorFontFamilyComponent, i10.EditorColorPickerComponent, i10.EditorForeColorDirective, i10.EditorBackColorDirective, i10.EditorInsertUnorderedListButtonDirective, i10.EditorInsertOrderedListButtonDirective, i10.EditorIndentButtonDirective, i10.EditorOutdentButtonDirective, i10.EditorBlockquoteDirective, i10.EditorSelectAllButtonDirective, i10.EditorUndoButtonDirective, i10.EditorRedoButtonDirective, i10.EditorCreateLinkButtonDirective, i10.EditorUnlinkButtonDirective, i10.EditorInsertFileButtonDirective, i10.EditorViewSourceButtonDirective, i10.EditorCleanFormattingButtonDirective, i10.EditorInsertTableButtonComponent, i10.EditorAddColumnBeforeButtonDirective, i10.EditorAddColumnAfterButtonDirective, i10.EditorAddRowBeforeButtonDirective, i10.EditorAddRowAfterButtonDirective, i10.EditorDeleteColumnButtonDirective, i10.EditorDeleteRowButtonDirective, i10.EditorDeleteTableButtonDirective, i10.EditorMergeCellsButtonDirective, i10.EditorSplitCellButtonDirective, i10.EditorPrintDirective, i10.EditorInsertImageButtonDirective, i12.Dropdown, i13.MultiSelect, i7.FormArrayName, i8.NgForOf, i7.FormGroupName, i14.Checkbox, i15.Button], styles: [".title[_ngcontent-%COMP%]{width:100%;margin-bottom:30px}.title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#67617e;padding:10px 0}.btn-css[_ngcontent-%COMP%]{padding:5px 10px;float:right;margin:8px 0}.clipbaord-content[_ngcontent-%COMP%]{padding:10px;border:1px solid #c3d0de!important}.clipbaord-content[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{text-align:left;height:13px!important}[_nghost-%COMP%]     .p-button .p-button-success .p-button-outlined{padding:0 3 0 3px!important;height:20px!important;min-width:10px!important}.font12px[_ngcontent-%COMP%]{font-size:12px}.back-link[_ngcontent-%COMP%]{padding-top:12px!important;padding-bottom:12px!important;text-decoration:none!important}.im-btn.im-btn-primary[_ngcontent-%COMP%]:hover{background-color:#fff!important;border:1px solid #19a0da!important;border-radius:4px!important;font-size:14px!important;text-transform:uppercase;color:#10a0da!important}.im-btn.im-btn-primary[_ngcontent-%COMP%]:disabled, .im-btn.im-btn-primary[_ngcontent-%COMP%]:disabled:hover{background-color:#f0f0f0!important;color:#a3a6b4!important;font-size:14px!important;font-family:Source Sans Pro;border:1px solid transparent!important}[_nghost-%COMP%]     .fr-toolbar.fr-top{border-radius:0 0 0 0!important;border:1px solid #c3d0de!important}[_nghost-%COMP%]     .fr-wrapper{border:unset!important}[_nghost-%COMP%]     .fr-second-toolbar{border-radius:0 0 0 0!important;border:unset!important}.fr-section-border[_ngcontent-%COMP%]{box-shadow:0 2px 4px rgba(0,0,0,.1)!important}.im-btn.im-btn-primary.im-btn-md[_ngcontent-%COMP%]:focus{background-color:transparent!important}.placeholder-list[_ngcontent-%COMP%]{width:100%;height:350px;overflow-y:auto;margin-bottom:20px;font-size:14px}.headTbl[_ngcontent-%COMP%]{background-color:#edf4fb;height:40px;padding:10px}.positionDetailsSection[_ngcontent-%COMP%]{background-color:#f7faff;color:#4a4a4a;padding:10px}.labelHeading[_ngcontent-%COMP%]{font-size:15px;word-wrap:break-word}.labelHeading.headlbl[_ngcontent-%COMP%]{font-size:13px;font-weight:600;white-space:nowrap}.docPath[_ngcontent-%COMP%]{border:1px solid #35abde!important;border-radius:20px!important;background:transparent;color:#35abde!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateViewerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-template-viewer',
                templateUrl: './lib-template-viewer.component.html',
                styleUrls: ['./lib-template-viewer.component.scss']
            }]
    }], function () { return [{ type: i1$1.Router }, { type: i1$1.ActivatedRoute }, { type: i2.MatDialog }, { type: i3.ClipboardService }, { type: i4.ToastrService }, { type: LibTemplateViewerService }, { type: i6.Store }, { type: i0.ChangeDetectorRef }, { type: i7.FormBuilder }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { templateEmailContentkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templateEmailContentkendoeditor"]
        }], templateEmailSignaturekendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templateEmailSignaturekendoeditor"]
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formBuilderInfo: [{
            type: Input
        }] }); })();

class LibTemplateViewerModule {
}
LibTemplateViewerModule.ɵfac = function LibTemplateViewerModule_Factory(t) { return new (t || LibTemplateViewerModule)(); };
LibTemplateViewerModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibTemplateViewerModule });
LibTemplateViewerModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            EditorModule,
            ClipboardModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibTemplateViewerModule, { declarations: [LibTemplateViewerComponent], imports: [PrimengLibraryModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        ClipboardModule], exports: [LibTemplateViewerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateViewerModule, [{
        type: NgModule,
        args: [{
                declarations: [LibTemplateViewerComponent],
                imports: [
                    PrimengLibraryModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    EditorModule,
                    ClipboardModule
                ],
                exports: [LibTemplateViewerComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-template-viewer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibTemplateViewerComponent, LibTemplateViewerModule, LibTemplateViewerService };
//# sourceMappingURL=lib-template-viewer.js.map
